import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import LoaderComponent from '../elements/LoaderComponent';

import { ContentContext,
         ConfigurationContext } from '../../context';
         
import TableCampaigns from './../elements/DataTable/TableCampaigns';

const WrapperStyled = styled.div`
    background-color: #fff;
`

const CampaignsTable = (props) => {

    const { filters = null } = props;

    const { getCampaigns,
            audits,
            setAudits,
            benefitRedeems, 
            setBenefitRedeems, } = useContext(ContentContext);

    const { panColors } = useContext(ConfigurationContext);

    const headCells = [
        {
            id: 'code',
            numeric: false,
            disablePadding: false,
            label: 'Código',
            align: 'left',
            sorteable: false,
        },
        {
            id: 'user_name',
            numeric: false,
            disablePadding: false,
            label: 'Tienda',
            align: 'left',
            sorteable: true,
        },
        {
            id: 'name',
            numeric: false,
            disablePadding: false,
            label: 'Usuario',
            align: 'left',
            sorteable: true,
        },
        {
            id: 'points',
            numeric: false,
            disablePadding: false,
            label: 'Formulario',
            align: 'left',
            sorteable: true,
        },
        {
            id: 'status',
            numeric: false,
            disablePadding: false,
            label: 'Moderación',
            align: 'left',
            sorteable: true,
        },
        {
            id: 'area',
            numeric: false,
            disablePadding: false,
            label: 'Embotelladora',
            align: 'left',
            sorteable: true,
        },
        {
            id: 'date',
            numeric: false,
            disablePadding: false,
            label: 'Fecha',
            align: 'left',
            sorteable: true,
        },
        {
            id: '',
            numeric: false,
            disablePadding: false,
            label: 'Acciones',
            align: 'right',
            sorteable: false,
        }
    ];
    
    useEffect(() => {
        setAudits(null);
        getCampaigns(0, 25, filters);

    }, [filters])

    useEffect(() => {
        return () => {
            setAudits(null);
        }
    }, [])
    
    return (
        <WrapperStyled pancolors={panColors}>
        {audits == null ?
            <LoaderComponent />
        :
        audits?.audits?.length ?
            <TableCampaigns
                headCells={headCells} 
                type={"audits"}
                title={"Auditorias"} 
                data={audits.audits} 
                getData={getCampaigns}
                totalRows={audits.total}
                filters={filters}
            />
            :
            <>No hay registros para mostrar</>
        }
        </WrapperStyled>
    );
}

export default CampaignsTable;